import { Component } from '@angular/core';

@Component({
    template: `placeholder for manage licenses`
})
export class ManageLicensesComponent {}
